<template>
  <div>
    <section class="catalogue-banner-section">
      <content-creator
        :settings="getBlobContents('catalog-list-banner')"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        name="catalog-list-banner"
        class="header-carousel"
        allowed-widgets="carousel,content-list,content-grid,vimeo-videos"
        @updateBlob="(data) => saveBlob('catalog-list-banner', data)"
      />
    </section>
    <b-container>
      <b-row>
        <b-col sm="12">
          <product-catalog
            v-model="settings"
            :filters="WineCatalogFilters"
            :sorters="WineCatalogSorters"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import products from 'wine-catalog/src/mockdata/wines.js'
import catalogloader from './winecatalog-preload-helper'
import contentCreatorMixin from 'src/app/content-creator-mixin'

const title = 'Wine Catalog'

export default {
  name: 'wine-catalogue-page',
  headData: true,
  headTitle: title,
  mixins: [
    contentCreatorMixin
  ],
  asyncData({ store, route }) {
    const __loader = () => {
      applogger.debug('wine-catalogue-page asyncData starting')
      return Promise.all([
        catalogloader(store),
        store.dispatch('blob/load', { blobID: 'catalog-list-banner', cacheOptions: { scope: 'global', ttl: 3600 * 12 } })
      ])
        .then(([productlist]) => {
          const catalogList = productlist.filter(item => {
            return item.productsettings.showincatalog
          })
          store.dispatch('productCatalog/setProducts', catalogList)
          store.dispatch('productCatalog/loadLowStockThreshold')
          store.dispatch('productCatalog/loadProductStock')
          if (store.getters['blob/isHeader']('catalog-list-banner')) {
            store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
          }
          applogger.debug('wine-catalogue-page asyncData complete')
        })
    }
    return store.dispatch('promisePool', {
      name: 'wine-catalog',
      resolve: __loader
    })
  },
  data: function() {
    return {
    }
  },
  computed: {
    WineCatalogSorters: function() {
      const defaultSorters = [
        {
          label: 'Default sort',
          sortBy: '',
          type: 'select'
        },
        {
          label: 'Sort by Price',
          sortBy: 'priceDiscounted',
          type: 'select',
          numeric: true
        },
        {
          label: 'Sort by Product Name',
          sortBy: 'title',
          type: 'select'
        },
        {
          label: 'Sort by Date added',
          sortBy: 'dateChanged',
          type: 'select',
          numeric: true
        }
      ]
      return this.$store.getters.getModuleSetting('wine-catalog', 'sorters', defaultSorters)
    },
    WineCatalogFilters: function() {
      const defaultFilters = [
        {
          label: 'Wine Type',
          filterBy: 'wine_type',
          type: 'select'
        },
        {
          label: 'Series/Collection',
          filterBy: 'series',
          type: 'select'
        },
        {
          label: 'Varietals',
          filterBy: 'varietal',
          type: 'select'
        },
        {
          label: 'Sweetness',
          filterBy: 'sweetness',
          type: 'range-slider',
          minLabel: 'Dry',
          maxLabel: 'Sweet'
        }
      ]
      return this.$store.getters.getModuleSetting('wine-catalog', 'filters', defaultFilters)
    },
    settings: {
      get: function() {
        return {
          filters: this.$store.state.productCatalog.filters,
          sorters: this.$store.state.productCatalog.sorters,
          sortDir: this.$store.state.productCatalog.sortDir,
          view: this.$store.getters['productCatalog/viewMode']
        }
      },
      set: function(value) {
        this.$store.dispatch('productCatalog/setCatalogFilters', value.filters)
        this.$store.dispatch('productCatalog/setCatalogSorter', value.sorters)
        this.$store.dispatch('productCatalog/setCatalogSortDirection', value.sortDir)
        this.$store.dispatch('productCatalog/setCatalogView', value.view)
      }
    }
  },
  watch: {
    '$route.query': {
      handler: function(updated, old) {
        const routeKeys = Object.keys(updated)
        if (routeKeys.length > 0) {
          const settings = JSON.parse(JSON.stringify(this.settings))
          const filterKeys = Object.keys(settings.filters)
          routeKeys.forEach((key) => {
            if (filterKeys.includes(key)) {
              settings.filters[key] = [updated[key]]
            }
          })
          this.settings = settings
        }
      }
    }
  },
  mounted() {
    if (this.$store.getters['blob/isHeader']('catalog-list-banner')) {
      this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
    }
  },
  title: () => {
    return title
  },
  created: function() {
    const filters = {
      dietary: [],
      wine_type: [],
      sweetness: [0, 5],
      series: [],
      varietal: [],
      varietals: [],
      collection: [],
      region: [],
      price: []
    }

    let defaultSort = this.$store.getters.getModuleSetting('wine-catalog', 'defaultSort', {})
    defaultSort = { order: '', direction: 'ASC', ...defaultSort }

    Promise.all([
      this.$store.dispatch('productCatalog/setCatalogFilters', filters),
      this.$store.dispatch('productCatalog/setCatalogSorter', defaultSort.order),
      this.$store.dispatch('productCatalog/setCatalogSortDirection', defaultSort.direction),
      this.$store.dispatch('productCatalog/setCatalogView', 'grid-view')
    ])
  }
}
</script>

<style>

</style>
